<div class="shopify-spinner">
  <span class="spinner-text" translate>PROCESSING</span>
  <div class="loading">
    <div class="spin-circle"></div>
  </div>
</div>
